import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ./node_modules/.1.9.2@rc-collapse/es/index.js
// module id = 290
// module chunks = 1